export default __webpack_public_path__ + "static/logo-9c2e7d7fde65d11052e65104cb0374bb.svg";